<template>
  <div class="services">
    <h1 class="servicesTitle">{{ $t("app.services.title") }}</h1>
    <div class="serviceCardContainer">
      <div class="row">
        <div
          class="col-sm-12 col-lg-4 serviceCol"
          v-for="(service, idx) in services"
          :key="idx"
        >
          <div class="servicesCard">
            <div class="serviceCardHeader">
              <vs-avatar size="69" dark>
                <i :class="`bx ${service.icon}`" />
              </vs-avatar>
              <h3 style="padding-left: 1rem">
                {{ service.name }}
              </h3>
            </div>
            <ul>
              <li v-for="(bullet, bidx) in service.bullets" :key="bullet + bidx">
                {{ bullet }}
              </li>
            </ul>
            <div class="serviceCardActions">
              <vs-button
                flat
                size="large"
                @click="() => openPlans(service.value)"
              >
                {{ $t("app.services.choosePlan.button") }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-dialog scroll full-screen v-model="active">
      <template #header>
        <div class="serviceDialogHeader">
          <h3 style="margin-bottom: 0">
            {{ $t("app.services.plan.title") }}
          </h3>
          <p style="margin-top: 0">
            {{ $t("app.services.plan.subtitle") }}
          </p>
        </div>
      </template>

      <div>
        <table v-if="activeService !== {} && mobile === false">
          <thead>
            <tr>
              <th>
                <div class="tableContact">
                  <h3>{{ $t("app.services.plan.contact") }}</h3>
                  <vs-button transparent @click="() => goTo('contact', $t('app.services.plan.contact.other'))">
                    {{ $t("app.services.plan.contact.action") }}
                    <i class="bx bx-chevron-right" style="margin-top: 2px" />
                  </vs-button>
                </div>
              </th>
              <th
                v-for="(pkg, idx) in activeService.packages"
                :key="idx + pkg.name"
                :style="
                  idx === activeService.packages.length - 1
                    ? 'border-right: 0;'
                    : ''
                "
              >
                <div class="tablePackage">
                  <h5>
                    {{ pkg.name }}
                  </h5>
                  <span class="tablePackageFrom">{{
                    $t("app.services.plan.price.from")
                  }}</span>
                  <h2>
                    {{ pkg.price }}
                    {{ $t("app.services.plan.price.currency") }}
                    <span class="tablePackagePrice"
                      >+{{ $t("app.services.plan.price.tax") }}</span
                    >
                  </h2>
                  <vs-button flat class="tablePackageButton" @click="() => goTo('contact', pkg.name)">
                    {{ $t("app.services.plan.choose.button") }}
                  </vs-button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(offer, idx) in activeService.offerings"
              :key="idx + offer.id"
              :style="
                idx === activeService.offerings.length - 1
                  ? 'border-bottom: 0;'
                  : ''
              "
            >
              <td>
                <div align="left">{{ offer.label }}</div>
              </td>
              <td
                v-for="(pkg, bidx) in activeService.packages"
                :key="bidx + pkg.name + 'includes'"
                :style="
                  bidx === activeService.packages.length - 1
                    ? 'border-right: 0;'
                    : ''
                "
              >
                <div class="tableIcon">
                  <vs-avatar
                    v-if="
                      pkg.includes.some((including) => including === offer.id)
                    "
                    success
                    size="30"
                  >
                    <i class="bx bx-check"></i>
                  </vs-avatar>
                  <vs-avatar v-else size="30">
                    <i class="bx bx-x"></i>
                  </vs-avatar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="mobile"
        >
          <div
            v-for="(pkg, idx) in activeService.packages"
            :key="idx + pkg.name"
            class="servicePackageCard">
              <div class="tablePackage">
                <h5>
                  {{ pkg.name }}
                </h5>
                <span class="tablePackageFrom">{{
                  $t("app.services.plan.price.from")
                }}</span>
                <h2>
                  {{ pkg.price }}
                  {{ $t("app.services.plan.price.currency") }}
                  <span class="tablePackagePrice"
                    >+{{ $t("app.services.plan.price.tax") }}</span
                  >
                </h2>
                <vs-button flat class="tablePackageButton" @click="() => goTo('contact', pkg.name)">
                  {{ $t("app.services.plan.choose.button") }}
                </vs-button>
              </div>
              <div style="padding: 0 1rem;">
                <ul>
                  <li
                    v-for="(feature, fidx) in pkg.includes"
                    :key="fidx"
                  >
                    {{ activeService.offerings.find((offer) => offer.id === feature).label }}
                  </li>
                </ul>
              </div>
          </div>
          <div
            class="servicePackageCard"
          >
            <div class="tableContact">
              <h3>{{ $t("app.services.plan.contact") }}</h3>
              <vs-button transparent @click="() => goTo('contact', $t('app.services.plan.contact.other'))">
                {{ $t("app.services.plan.contact.action") }}
                <i class="bx bx-chevron-right" style="margin-top: 2px" />
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-dialog>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Contact',
  props: {
    setActive: Function,
    setContactForm: Function,
  },
  data() {
    return {
      mobile: false,
      services: [
        {
          name: this.$t('app.services.design'),
          icon: 'bxs-paint',
          bullets: [
            this.$t('app.services.design.logo'),
            this.$t('app.services.design.branding'),
            this.$t('app.services.design.advertisement'),
            this.$t('app.services.design.slides'),
          ],
          value: 'graphic-design',
        },
        {
          name: this.$t('app.services.printing'),
          icon: 'bxs-printer',
          bullets: [
            this.$t('app.services.printing.businessCards'),
            this.$t('app.services.printing.flyers'),
            this.$t('app.services.printing.banners'),
            this.$t('app.services.printing.menu'),
            this.$t('app.services.printing.clothing'),
          ],
          value: 'printing',
        },
        {
          name: this.$t('app.services.webDesign'),
          icon: 'bx-code-alt',
          bullets: [
            this.$t('app.services.webDesign.landing'),
            this.$t('app.services.webDesign.custom'),
            this.$t('app.services.webDesign.webapps'),
            this.$t('app.services.webDesign.ecommerce'),
          ],
          value: 'web-development',
        },
      ],
      active: false,
      activeService: {},
      design: {
        name: this.$t('app.contact.form.services.design'),
        offerings: [
          {
            label: this.$t('app.services.plan.design.logo'),
            id: 1,
          },
          {
            label: this.$t('app.services.plan.design.proposals'),
            id: 2,
          },
          {
            label: this.$t('app.services.plan.design.proposals.changes'),
            id: 3,
          },
          {
            label: this.$t('app.services.plan.design.assets'),
            id: 4,
          },
          {
            label: this.$t('app.services.plan.design.colorTypography'),
            id: 5,
          },
          {
            label: this.$t('app.services.plan.design.cards'),
            id: 6,
          },
          {
            label: this.$t('app.services.plan.design.mediaAssets'),
            id: 7,
          },
          {
            label: this.$t('app.services.plan.design.brandManual'),
            id: 8,
          },
        ],
        packages: [
          {
            name: this.$t('app.services.plan.design.package.starter'),
            price: '$359',
            includes: [1, 2, 3, 4, 5],
          },
          {
            name: this.$t('app.services.plan.design.package.entrepreneur'),
            price: '$459',
            includes: [1, 2, 3, 4, 5, 6],
          },
          {
            name: this.$t('app.services.plan.design.package.tycoon'),
            price: '$499',
            includes: [1, 2, 3, 4, 5, 6, 7, 8],
          },
        ],
      },
      priting: {
        name: this.$t('app.contact.form.services.webDesign'),
        offerings: [
          {
            label: this.$t('app.services.plan.design.logo'),
            id: 1,
          },
          {
            label: this.$t('app.services.plan.design.proposals'),
            id: 2,
          },
          {
            label: this.$t('app.services.plan.design.proposals.changes'),
            id: 3,
          },
          {
            label: this.$t('app.services.plan.design.assets'),
            id: 4,
          },
          {
            label: this.$t('app.services.plan.design.colorTypography'),
            id: 5,
          },
          {
            label: this.$t('app.services.plan.design.cards'),
            id: 6,
          },
          {
            label: this.$t('app.services.plan.design.mediaAssets'),
            id: 7,
          },
          {
            label: this.$t('app.services.plan.design.brandManual'),
            id: 8,
          },
        ],
        packages: [
          {
            name: this.$t('app.services.plan.design.package.starter'),
            price: '$359',
            includes: [1, 2, 3, 4, 5],
          },
          {
            name: this.$t('app.services.plan.design.package.entrepreneur'),
            price: '$459',
            includes: [1, 2, 3, 4, 5, 6],
          },
          {
            name: this.$t('app.services.plan.design.package.tycoon'),
            price: '$499',
            includes: [1, 2, 3, 4, 5, 6, 7, 8],
          },
        ],
      },
      webDesign: {
        name: this.$t('app.contact.form.services.webDesign'),
        offerings: [
          {
            label: this.$t('app.services.plan.webDesign.unique'),
            id: 1,
          },
          {
            label: this.$t('app.services.plan.webDesign.mobileSupport'),
            id: 2,
          },
          {
            label: this.$t('app.services.plan.webDesign.contactInfo'),
            id: 3,
          },
          {
            label: this.$t('app.services.plan.webDesign.contactForm'),
            id: 4,
          },
          {
            label: this.$t('app.services.plan.webDesign.subscribeForm'),
            id: 5,
          },
          {
            label: this.$t('app.services.plan.webDesign.admin'),
            id: 6,
          },
          {
            label: this.$t('app.services.plan.webDesign.payment'),
            id: 7,
          },
          {
            label: this.$t('app.services.plan.webDesign.training'),
            id: 8,
          },
        ],
        packages: [
          {
            name: this.$t('app.services.plan.webDesign.package.starter'),
            price: '$549',
            includes: [1, 2, 3, 4],
          },
          {
            name: this.$t('app.services.plan.webDesign.package.entrepreneur'),
            price: '$899',
            includes: [1, 2, 3, 4, 5, 6],
          },
          {
            name: this.$t('app.services.plan.webDesign.package.tycoon'),
            price: '$1999',
            includes: [1, 2, 3, 4, 5, 6, 7, 8],
          },
        ],
      },
    };
  },
  methods: {
    i18(id) {
      return this.$t(id);
    },
    openPlans(service) {
      switch (service) {
        case 'graphic-design':
          this.activeService = this.design;
          break;
        case 'printing':
          this.activeService = this.priting;
          break;
        case 'web-development':
          this.activeService = this.webDesign;
          break;
        default:
          break;
      }
      this.active = true;
    },
    goTo(to, packageName) {
      const contactForm = {
        service: this.activeService.name,
        packageName,
      };
      this.setContactForm(contactForm);
      this.setActive(to);
      this.$router.push({ path: `/${to}` });
    },
  },
  mounted() {
    const mediaQuery = window.matchMedia('(max-width: 590px)');
    if (mediaQuery.matches) {
      // when screen width is less than 590px
      console.log('executing');
      this.mobile = true;
    }
  },
};
</script>

<style scoped>
.servicesTitle {
  font-size: 2.4rem;
  margin: 0 0;
}

.servicesSubtitle {
  font-size: 2rem;
  font-weight: 400;
  margin: 0 0;
}

.serviceCol {
  width: auto;
}

.serviceCardContainer{
  display: flex;
  justify-content: center;
}

.servicesCard {
  margin-top: 1rem;
  background: #ffffff;
  width: 80%;
  -webkit-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  border-radius: 20px;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  position: relative;
  padding: 2rem;
  width: 100%;
}

.serviceCardHeader {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding-bottom: 1rem;
}

.serviceCardActions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.servicesCard .vs-avatar i {
  font-size: 2.5rem;
}

.serviceDialogHeader {
  text-align: center;
}
/* Table related stuff */

table {
  background: #ffffff;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  -webkit-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  border-radius: 20px !important;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}

table caption {
  font-size: 1.5em;
  margin: 0.5em 0 0.75em;
}

table tr {
  border-bottom: 1px solid rgb(230, 230, 230);
  padding: 0.35em;
}

table th,
table td {
  border-right: 1px solid rgb(230, 230, 230);
  padding: 0.625em;
  text-align: center;
}

table th {
  font-size: 0.85em;
  text-transform: uppercase;
}

/*
@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }

  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }

  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }

  table td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }

  table td:last-child {
    border-bottom: 0;
  }
}
*/

.tableIcon {
  display: flex;
  width: 100%;
  justify-content: center;
}

.tablePackage {
  text-align: left;
  padding: 0 1rem;
}

.tablePackage h2 {
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
}

.tablePackage h5 {
  margin: 0;
}

.tablePackagePrice {
  font-size: 0.7rem;
  font-weight: 400;
  color: grey;
}

.tablePackageButton {
  margin-left: 0px;
}

.tableContact {
  text-align: left;
}

.tableContact h3 {
  margin: 0 0 0 1rem;
}

.tablePackageFrom {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 0.7rem;
  font-weight: 400;
}

.servicePackageCard {
  background: #ffffff;
  margin: 0;
  padding: 1rem;
  width: 90%;
  -webkit-box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, var(--vs-shadow-opacity));
  border-radius: 20px !important;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
</style>
